import { INavMenu, INavMenuItem, IUser } from "@types";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import * as S from "./style/DesktopNavbar.styled";
import NavbarHeader from "./ui/desktop/NavbarHeader";
import NavbarMenu from "./ui/desktop/NavbarMenu";
import NavbarSubmenu from "./ui/desktop/NavbarSubmenu";

interface DesktopNavbarProps {
  user: IUser | null;
  navMenuItems: INavMenu | null;
}

const DesktopNavbar: React.FC<DesktopNavbarProps> = ({
  user,
  navMenuItems,
}) => {
  const { pathname } = useLocation();

  const [activeMenuItemPath, setActiveMenuItemPath] = useState(pathname);
  const [submenuHeight, setSubmenuHeight] = useState(230);
  const [activeSubmenu, setActiveSubmenu] = useState<INavMenuItem[] | null>(
    null
  );

  useEffect(() => {
    setActiveMenuItemPath(pathname);
  }, [pathname]);

  const handleMenuHover = useCallback(
    (item: INavMenuItem) => {
      if (!navMenuItems) return;
      if (item.height) setSubmenuHeight(item.height);
      setActiveSubmenu(navMenuItems[item.text] || null);
    },
    [navMenuItems]
  );

  return (
    <S.Nav>
      {activeSubmenu && <S.SubmenuBackground height={submenuHeight} />}

      <S.NavbarContainer>
        <NavbarHeader user={user} />
        <NavbarMenu
          pathname={pathname}
          navMenuItems={navMenuItems}
          activeMenuItemPath={activeMenuItemPath}
          setActiveMenuItemPath={setActiveMenuItemPath}
          handleMenuHover={handleMenuHover}
        />
      </S.NavbarContainer>

      <NavbarSubmenu
        submenu={activeSubmenu}
        setActiveSubmenu={setActiveSubmenu}
        submenuHeight={submenuHeight}
      />
    </S.Nav>
  );
};

export default DesktopNavbar;
